import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

export const store = configureStore({
  reducer: rootReducer,
});

// general syntax
export type RootState = ReturnType <typeof store.getState>
export type AppDispatch = typeof store.dispatch

